





















































































import { Component, Vue, Watch } from 'vue-property-decorator';
// import Header from './Header.vue';
import Navigation from '@/layout/slider/navigation.vue';
import './css/Layout.less';
import { getQueryString } from '@/Api/api_data';
import Api from '@/Api/api_simulaion';
import { logout } from '@/Api/auth';
import { AuthInformation } from '@/store/modules/auth';
import Diagram from '@/views/Diagram/index';
import { PlanList, ProjectInfo } from '@/prioritization/interface/interface';
import api from '@/Api/api_data';

/**
 * 框架入口文件
 */
@Component({
    components: {
        // Header,
        Diagram,
        Navigation,
    },
})
export default class Layout extends Vue {
    /**主题色 */
    colorList = ['dark', 'light'];

    /** */
    flag = false;
    /**
     * path
     */
    @Watch('$route.name', { immediate: true, deep: true })
    onOption(_nVal: string, _oVal: string): void {
        this.currentNavigation = _nVal;
    }

    /**  */
    currentNavigation = 'data';

    /** */
    get userInfo(): AuthInformation {
        return this.$store.getters.getUserInfo || {};
    }

    /**
     *获取计划列表
     */
    get planList(): PlanList[] {
        return this.$store.getters.getPlanList;
    }

    set planList(value: PlanList[]) {
        this.$store.commit('setPlanList', value);
    }
    /**
     * projectInfo
     */
    get projectInfo(): ProjectInfo {
        return this.$store.state.projects;
    }

    /**
     *
     */
    get simuId(): string | Array<string | null> {
        return this.$route.query['simu_id'];
    }

    /**
     * @author guan
     * @description
     */
    set isLightTheme(value: boolean) {
        if (value) {
            this.$store.commit('setTheme', 'light');
        } else {
            this.$store.commit('setTheme', 'dark');
        }
    }
    /**
     *
     */
    get isLightTheme(): boolean {
        return this.$store.getters.getTheme === 'light';
    }
    /**
     * 获得方案数据
     */
    /**
     *
     */
    async loadPlanList(): Promise<void> {
        this.planList = [];
        if (this.taskId !== '') {
            const data = await Api.getOptimizationResult({ resultType: 0, taskid: this.taskId });
            if (data.data.length !== 0) {
                this.planList = data.data;
            }
        } else {
            this.planList = [];
        }
    }

    /**
     * 获得taskId
     */
    get taskId(): string {
        return this.$store.getters.getTaskId;
    }

    /**
     * 获得currentPlanId
     */
    get currentPlanId(): number {
        return this.$store.getters.getCurrentPlanId;
    }

    /**
     *设置任务id
     */
    async setTaskId(): Promise<void> {
        const simuId = this.$route.query['simu_id'];
        if (typeof simuId === 'string' && simuId !== '') {
            await Api.getLastSimulationTask({ simuid: getQueryString()['simu_id'] }).then((res) => {
                if (res.data != null) {
                    this.$store.commit('setTaskId', res.data.task_id);
                } else {
                    this.$store.commit('setTaskId', -1);
                }
            });
        }
    }

    /**
     *
     */
    @Watch('simuId')
    async simuIdChange(): Promise<void> {
        await this.setTaskId();
        await this.loadPlanList();
        const r = await api.getSimuData({ id: getQueryString()['simu_id'] });
        if (r.publicLevel >= 10) {
            this.$store.commit('setIsTypicalLibraryEditMode', true);
        } else {
            this.$store.commit('setIsTypicalLibraryEditMode', false);
        }
    }

    /**
     * @author: guan
     * @description: 设置默认的active
     */
    async mounted(): Promise<void> {
        void this.$store.dispatch('getProjectListSyc', this.$route.query.simu_id);
        await this.setTaskId();
        await this.loadPlanList();
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        this.currentNavigation = this.$router.currentRoute.matched[1].name || 'data';
        const r = await api.getSimuData({ id: getQueryString()['simu_id'] });
        if (r.publicLevel >= 10) {
            this.$store.commit('setIsTypicalLibraryEditMode', true);
        } else {
            this.$store.commit('setIsTypicalLibraryEditMode', false);
        }
    }

    /**
     * 打开方案
     * 跳转页面
     */
    openPlan(navigation: string, it: PlanList): void {
        this.$store.commit('setCurrentPlanId', it.id);
        this.currentNavigation = 'evaluate';
        this.openPage(navigation);
    }

    /**
     * @author: guan
     * @description:  打开地址
     * @param  params 跳转的参数名
     * @return void
     */
    openPage(params: string): void {
        this.currentNavigation = params;
        const query = this.$route.query;
        const navigationRecord = this.$store.getters.getNavigationRecords[this.currentNavigation];
        let name = this.currentNavigation;
        //如果记录存在则替换name
        if (navigationRecord != null && navigationRecord !== '') {
            name = navigationRecord;
        }
        console.log('openPage name', name);
        const route = {
            name: name,
            query: query,
        };

        this.$router.push(route).catch((e) => {
            if (!String(e).includes('Avoided redundant navigation to current location')) {
                throw e;
            }
        });
    }

    /**
     *回到首页
     */
    backToHomePage(): void {
        const url = this.$store.state.iesMode ? '/account/ies' : '/account/ies-opt';
        window.open(url, '_self');
    }

    /**
     * @author guan
     * @description
     * @returns void
     * @param params
     */
    menuClick(params: { item: unknown; key: string; keyPath: string[] }): void {
        switch (params.key) {
            case '1':
                {
                    const url = this.$store.state.iesMode ? '/account/ies' : '/account/ies-opt';
                    window.open(url, '_self');
                }
                break;
            case '3':
                {
                    logout()
                        .then(() => {
                            window.open('/account/login', '_self');
                        })
                        .catch(() => {
                            void this.$message.error('退出失败!');
                        });
                }
                break;
            default:
                break;
        }
    }
}
